import list from 'src/modules/achievement/list/achievementListReducers';
import form from 'src/modules/achievement/form/achievementFormReducers';
import destroy from 'src/modules/achievement/destroy/achievementDestroyReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  destroy,
});

